import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
@Component({
  selector: 'app-member-matrix',
  templateUrl: './member-matrix.component.html',
  styleUrls: ['./member-matrix.component.css']
})
export class MemberMatrixComponent implements OnInit {
  showSpinner = false;
  institution: string;
  institutionid: number;
  action: string;
  membermatrixform;
  
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private institutionService: InstitutionsService) { }

  ngOnInit() {
    this.membermatrixform = this.fb.group({
      size: ['A4', Validators.required],
      format: ['pdf', Validators.required]
    });
  
    this.route.params.subscribe(p => {
      if (p) {
        this.institutionid = +p.id;
        this.getInstitution();
      }
    });
  }

  getInstitution() {
    this.institutionService.getInstitutionByIdAsync(this.institutionid).subscribe(i => {
      this.institution = i.shortName + ' - ' + i.name;
    });
  }

  generateReport() {
    const params = {
      Format: this.membermatrixform.get('size').value,
      ExportOptions: this.membermatrixform.get('format').value,
      InstitutionId: this.institutionid
    };
    this.institutionService.CreateInstitutionMatrixReportForDownload(params).subscribe(response => {
      if (response) {
        
        const format = this.membermatrixform.get('format').value;
        let linkSource = format === 'pdf' ? 'data:application/pdf;base64,' + response.fileContents : 'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document/;base64,' + response.fileContents;
        const downloadLink = document.createElement("a");
        const fileName = 'Medlemsmatrikel.' + format;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        this.showSpinner = false;
      }
    });

  }

  cancel() {
    this.router.navigate(['institutions/id/', this.institutionid]);
  }
}
